import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import CommonStepper from 'src/components/common/commonStepper'
import CreateMoreBtn from 'src/components/common/createMoreBtn'
import FilterSection from 'src/components/common/filterSection'
import AddEditLesson from 'src/components/lesson/AddEditLesson'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteChapterById, GetChapters } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetChapterTableColumns } from 'src/util/columns'

import AddEditChapter from '../components/chapter/AddEditChapter'

const steps = [
  'Create Chapter',
  'Create Lesson',
];

const ChapterList = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const [searchText, setSearchText] = useState(null)
  const [activeStep, setActiveStep] = useState(0);
  const [firstStepData, setFirstStepData] = useState(null);
  const params = new URLSearchParams(location.search);
  const chapterId = params.get("_id");
  const courseId = params.get("courseId");

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'chapters',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  // filter chapter by chapterId
  useEffect(() => {
    if (!chapterId) return;
    setCustomFilterQuery(prev => ({
      ...(prev || {}),
      _id: chapterId,
    }));
  }, [chapterId]);

  // filter chapter by courseId
  useEffect(() => {
    setCustomFilterQuery(prev => {
      const updatedQuery = { ...(prev || {}) };

      if (courseId) {
        updatedQuery.unit = courseId;
      } else {
        delete updatedQuery.unit;
      }

      return updatedQuery;
    });
  }, [courseId]);


  // set chapter data for add lesson by action button
  useEffect(() => {
    if (recordToEdit) {
      setFirstStepData({
        languageId: recordToEdit?.course?._id,
        courseId: recordToEdit?.unit?._id,
        chapterId: recordToEdit?._id,
        difficultyLevel: recordToEdit?.difficultyLevel,
      });
    }
  }, [recordToEdit]);


  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteChapterById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetChapterTableColumns(), []);

  const actionTitle = Object.keys(recordToEdit || {}).length === 0 ? "create-chapter" : "";

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          {/* addButton filters & search section  */}
          <FilterSection
            type="Chapter"
            path="chapters"
            dispatcher={GetChapters}
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            setCustomFilterQuery={setCustomFilterQuery}
          />

          {/* Chapter data List */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="Chapter"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
              addChildActionBtnTitle="Create Lesson"
              addChildActionBtnClick={() => {
                setActiveStep(1);
              }}
              viewChildActionBtnTitle="View lesson"
              viewChildActionBtnUri={`/app/lessons?chapterId=`}
            />
          </Box>


          {/* Add & Update Chapter & Add lesson modal*/}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={
              activeStep === 0
                ? `${actionTitle ? "Create" : "Update"} chapter`
                : "Create Lesson"
            }
            onClose={() => {
              setRecordToEdit();
              setFirstStepData(null);
              setActiveStep(0)
            }}
            maxWidth="md"
          >
            {/*Stepper Box */}
            {actionTitle && <CommonStepper steps={steps} activeStep={activeStep} />}

            <Box mt={2}>
              {/* Add & Update course form */}
              {activeStep === 0 && (
                <AddEditChapter
                  selectedRow={recordToEdit}
                  refetch={refetch}
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                    setActiveStep(0)
                  }}
                  setFirstStepData={setFirstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {/* Add & Update chapter form */}
              {activeStep === 1 && (
                <AddEditLesson
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                    setActiveStep(0)
                  }}
                  refetch={refetch}
                  firstStepData={firstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {/* Add practice success message & add new practice button */}
              {activeStep === 2 && (
                <CreateMoreBtn
                  notification="Lesson created successfully!"
                  createMoreBtnTitle="+ Create more Lesson"
                  onCreate={() => {
                    setActiveStep(1)
                  }}
                  onClose={() => {
                    setRecordToEdit()
                    setFirstStepData(null);
                    setActiveStep(0)
                  }}
                />
              )}

            </Box>
          </AddUpdateDialog>

        </Container>
      </Box>
    </>
  )
}

export default ChapterList
